import { useState, useEffect } from 'react';

const API_URL = '/buda-api/v2/markets/usdt-clp/ticker';

export const useTokenPrice = () => {
    const [priceData, setPriceData] = useState({
        usdtClp: 0,
        xcoClp: 0,
        lastUpdated: null
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchPrice = async () => {
        try {
            setLoading(true);
            const response = await fetch(API_URL);
            if (!response.ok) throw new Error('Network response was not ok');

            const data = await response.json();
            // Data format: { ticker: { last_price: ["897.94", "CLP"], ... } }

            const lastPrice = parseFloat(data.ticker.last_price[0]);

            setPriceData({
                usdtClp: lastPrice,
                xcoClp: lastPrice * 10, // 1 XCO = 10 USDT Policy
                lastUpdated: new Date()
            });
            setError(null);
            return lastPrice; // Return for direct usage
        } catch (err) {
            console.error("Error fetching price from Buda:", err);
            setError(err.message);
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPrice();
        const interval = setInterval(fetchPrice, 60000); // 60 seconds Refresh
        return () => clearInterval(interval);
    }, []);

    return { ...priceData, loading, error, refresh: fetchPrice };
};
